import Api from "./Api";

export default {
    send: function (credentials) {
        var url = window.$application.config.api.pdc_send_mail;

        var form = new FormData();
        form.append('xmloutput',credentials.xmloutput);
        form.append('lang',credentials.lang);
        form.append('g-recaptcha-response',credentials.g_recaptcha_response);
        form.append('firstname',credentials.firstname);
        form.append('lastname',credentials.lastname);
        form.append('from',credentials.from);
        form.append('to',credentials.to);
        form.append('message',credentials.message);

        return Api().post(url, form);
    },
}
